
<div class="product-tile" [ngClass]="{ 'has-details': hasDetails, 'is-in-cart': isInCart }">

  <!-- favorite -->
  <div class="favorite" [ngClass]="{'-active': isFavorite}">
    <a>
      <i
        (click)="toggleFavorite($event)"
        class="fa"
        [ngClass]="{'fa-heart': isFavorite, 'fa-heart-o': !isFavorite}"></i>
    </a>
  </div>

  <div class="image-and-text-clickable-area-for-details" (click)="openDetails()">

    <!-- image -->
    <div class="image-wrapper">
      <img hidden [src]="productImage?.modal?.img" class="image-check" alt="" (error)="onImageError('/assets/images/no-image-placeholder.png')">
      <div *ngIf="imgUrl" [appFlyToCart]="product?._id" cartSelector="cartbutton" class="image" [ngStyle]="{'background-image': 'url(' + imgUrl + ')'}">
        <div class="content">
        </div>
      </div>
      <div *ngIf="!imgUrl" [appFlyToCart]="product?._id" cartSelector="cartbutton" class="image" [ngStyle]="{'background-image': 'url(' + productImage?.modal?.img + ')'}">
        <div class="content">
        </div>
      </div>
    </div>


    <!-- text -->
    <div class="text">

      <h3>{{ name }}</h3>

      <p class="productcode">
        {{ displayCode }}
      </p>

      <!-- attributes -->
      <ul class="attributes" *ngIf="catalogItemPageSettings?.showAttributes">
        <ng-container *ngFor="let productParam of product?.attrs">
          <ng-container *ngFor="let param of catalogItemPageSettings?.showAttributes">
            <li *ngIf="productParam.key === param">
                <span> {{ 'entity.label.product.attr.' + productParam.key | lowercase | translate }} </span>
                <span> {{ productParam.value }} </span>
            </li>
          </ng-container>
        </ng-container>
      </ul>

      <!-- facets -->
      <ul class="attributes" *ngIf="catalogItemPageSettings?.showFacets?.length && productFacets?.length">
        <ng-container *ngFor="let productFacet of productFacets">
          <li>
            <span class="-bold"> {{ productFacet?.name }} </span>
            <span>
              <ng-container *ngFor="let value of productFacet?.values; let i = index; let last = last">
                <ng-container *ngIf="value">
                  {{ last ? value : value + ', ' }}
                </ng-container>
              </ng-container>
            </span>
          </li>
        </ng-container>
      </ul>

      <!-- besteleenheid en staffels -->
      <div *ngIf="hasPrice">
        <p class="minquantity" *ngIf="prices && prices[0]?.minQuantity">
          {{ 'catalog.per-pieces' | translate: {count:  (prices && prices[0]?.minQuantity) } }}
        </p>

        <!-- staffels -->
        <ul class="prices" *ngIf="hasMultiplePrices && prices?.length > 1">
          <li class="price" *ngFor="let price of prices | slice: 1; let index = index">
            <h6 *ngIf="hasMultiplePrices">
              {{ 'catalog.price-from' | translate: {quantity: price?.minQuantity} }} {{ price.price | price:price.currency }}
            </h6>
          </li>
        </ul>
     </div>

      <!-- backorder -->
      <p class="backorder" *ngIf="isProductInBackorder">
        {{ 'product.backorder-info' | translate:{ totalInBackOrder: product?.backorderInfo.totalInBackorder | numberFormat, week: product?.backorderInfo.firstDeliveryDate | momentDateFormat: 'w' } }}
      </p>

      <p class="previously-ordered" *ngIf="isProductPreviouslyOrdered">
        {{ 'product.total-previously-ordered' | translate:{ totalPreviouslyOrdered: product?.totalPreviouslyOrdered | numberFormat } }}
      </p>

    </div> <!-- // text -->
  </div> <!-- // image and text clickable area for details -->

  <!-- quantity picker -->
  <div class="price-and-quantitypicker" [ngClass]="{ 'price-and-quantitypicker-relative' : quantityPickerRelative }" *ngIf="hasPrice">

     <!-- RELATIVE -->
     <div class="current-price" *ngIf="!showQuantityPickerAnimated && canBuy">
      <span>{{ currentPrice.price | price:currentPrice.currency }}</span>
      <span class="legend">
        {{ 'catalog.per-piece' | translate }}
      </span>
    </div>
    <div class="quantity" *ngIf="!showQuantityPickerAnimated">
      <app-quantity-picker *ngIf="isTileOrderable && canBuy && !showQuantityPickerAnimated" [itemId]="product?._id"
        [value]="actualQuantity" [stepping]="stepping" [minQuantity]="minQuantity" (quantityChanged)="quantityChanged($event)">
      </app-quantity-picker>
    </div>

    <!-- ABSOLUTE -->
    <div class="price" *ngIf="showQuantityPickerAnimated">
      <span>{{ currentPrice.price | price:currentPrice.currency }}</span>
      <span class="legend">
        {{ 'catalog.per-piece' | translate }}
      </span>
    </div>
    <div class="quantity" *ngIf="showQuantityPickerAnimated">
      <app-quantity-picker-animated *ngIf="isTileOrderable && canBuy && showQuantityPickerAnimated" [itemId]="product?._id" [value]="actualQuantity"
        [minQuantity]="minQuantity" (quantityChanged)="quantityChanged($event)" [ngClass]="{ 'backorder-mode' : isProductInBackorder }"
        [stepping]="stepping">
      </app-quantity-picker-animated>
    </div>

  </div> <!-- // quantitypicker -->

  <!-- Stock -->
  <app-stock-info *ngIf="catalogItemPageSettings?.showStockInfo" [product]="product">
  </app-stock-info>

  <!-- detail link 
  <a [routerLink]="'/catalog/product/' + product.code" class="btn btn-info">Detail page</a>
  -->

</div>

